import { API_ENDPOINTS } from '@/api/endpoints';
import { Area } from '@/stores/SubprojectStore';
import { apiFetch } from '@/util/apiClient';
import { useQuery } from '@tanstack/react-query';
import { Cooking, CookingWithMetrics } from '../types';
import { addMetricsToResource } from './techMetrics';

export const useCookingWithMetrics = (conditionedSpaceArea?: Area) => {
  return useQuery<Cooking[], Error, CookingWithMetrics[]>({
    queryKey: ['cooking', 'withMetrics', conditionedSpaceArea?.value],
    queryFn: () => apiFetch<Cooking[]>(API_ENDPOINTS.COMMON.technology.cooking),
    enabled: conditionedSpaceArea !== undefined,
    select: (data) => addMetricsToResource(data, conditionedSpaceArea),
  });
};
